var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullHeight mx-0"},[_c('h2',{staticClass:"event-title"},[_vm._v(" Redirecting to Springer "),_c('v-progress-circular',{staticClass:"progress-bar",attrs:{"model-value":"20","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }